document.addEventListener('DOMContentLoaded', function() {
  // Hero burger (homepage)
  var heroBurger = document.getElementById('mbal-hero-burger');
  var heroMobile = document.getElementById('mbal-hero-mobile');
  if (heroBurger && heroMobile) {
    heroBurger.addEventListener('click', function() {
      heroMobile.classList.toggle('open');
    });
  }
  // Standalone header burger (other pages)
  var burger = document.getElementById('mbal-burger');
  var menu = document.getElementById('mbal-mobile');
  if (burger && menu) {
    burger.addEventListener('click', function() {
      menu.classList.toggle('open');
    });
  }
});
